<template>
    <storefront-node :storefront-prefix="storefrontPrefix" />
</template>

<script setup lang="ts">
import { inject } from 'vue'
import { definePageMeta } from '#imports'
import StorefrontNode from '~/components/Storefront/StorefrontNode.vue'

definePageMeta({
    // Embedded public content may be indexed only as part of its host page.
    searchIndexing: 'embed',
    layout: 'embed'
})

const storefrontPrefix = inject('STOREFRONT_PREFIX')
</script>
